var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-tooltip', { attrs: { "placement": "top", "disabled": _vm.list.length < 3 } }, [_c('div', { attrs: { "slot": "content" }, slot: "content" }, _vm._l(_vm.list, function (item, index) {
    return _c('p', { key: index, staticClass: "channel-name" }, [_vm._v("\n      " + _vm._s(item) + "\n    ")]);
  }), 0), _vm._v(" "), _c('div', [!_vm.list.length ? _c('span', [_vm._v(_vm._s('All'))]) : _c('div', [_vm._l(_vm.list.filter(function (el, num) {
    return num < 3;
  }), function (item, index) {
    return _c('p', { key: index, staticClass: "channel-name" }, [_vm._v("\n        " + _vm._s(item) + "\n      ")]);
  }), _vm._v(" "), _vm.list.length > 3 ? _c('span', [_c('i', { staticClass: "el-icon-info" })]) : _vm._e()], 2)])]);
};
var staticRenderFns = [];

export { render, staticRenderFns };